exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.swiper-slide {\n  position: relative;\n}\n", "", {"version":3,"sources":["F:/develop/JCeshop-wx/src/components/swiper/swiper-item.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB","file":"swiper-item.vue","sourcesContent":["\n.swiper-slide {\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-759d47ee","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@7.1.0@sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/swiper/swiper-item.vue
// module id = Bnn5
// module chunks = 83